module.exports = __webpack_public_path__ + "static/media/magic-13.83002a4d.svg";